import { render, staticRenderFns } from "./LayoutInteressenten.vue?vue&type=template&id=35d125ae&scoped=true"
import script from "./LayoutInteressenten.vue?vue&type=script&lang=js"
export * from "./LayoutInteressenten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d125ae",
  null
  
)

export default component.exports